import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import InputNumber from 'components/Fields/ReduxForm/InputNumber';
import { goToStep, uploadFile } from 'actions/kyb';
import * as clevertapKyb from 'clevertap/kyb';
import { error as msgError } from 'actions/notifications';
import styles from './style.css';
import Modal from './Modal';

const validate = values => {
  const errors = {};
  if (!values.name) {
    errors.name = 'This field is required';
  } else if (values.name.trim().length < 1) {
    errors.name = 'This field is required';
  }
  if (!values.id) {
    errors.id = 'This field is required';
  } else if (values.id.trim().length < 1) {
    errors.id = 'This field is required';
  } else if (values.id.length !== 16) {
    errors.id = 'Enter a valid ID (KTP) Number';
  }
  return errors;
};

const inputField = field => {
  return (
    <div>
      <input
        {...field.input}
        type={field.type || 'text'}
        maxLength={field.maxLength}
        className={`form-control ${
          field.meta.touched && field.meta.error ? styles['input-error'] : ''
        }`}
        placeholder={field.placeholder}
      />
      <small className={styles.error}>
        {field.meta.touched ? field.meta.error : ''}
      </small>
    </div>
  );
};

let DocumentUpload = class DocumentUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      url: null,
      file: null,
      img: null,
    };
    if (props.data.kybForm.kybIdentity) {
      this.initializeForm();
    } else {
      const {
        first_name: firstName,
        last_name: lastName,
      } = props.data.moka.user;
      this.props.initialize({
        name: `${firstName} ${lastName !== null ? lastName : ''}`,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { idCard } = nextProps.data.kybForm;
    const { url, img } = this.state;
    this.setState({
      img: idCard,
      url: idCard !== img ? null : url,
    });
  }

  initializeForm() {
    const { kybIdentity } = this.props.data.kybForm;
    const initData = {
      name: kybIdentity.KTP_NAME,
      id: kybIdentity.KTP_NUMBER,
    };
    this.props.initialize(initData);
  }

  componentDidMount() {
    $('body').append($('#kybInfo'));
    $('body').append($('#upload-photo'));
    const {
      phone,
      email,
      business: {
        business_category_id: businessCategory,
        province: businessLocation,
      },
    } = this.props.data.moka.user;
    const {
      business_entity_type: businessEntityType,
      address,
      city,
      kecamatan,
      name: businessName,
      province,
      postal_code: postalCode,
    } = this.props.data.kybForm.kybData;
    const clevertapData = {
      email,
      phone,
      businessCategory,
      businessLocation,
      businessEntityType,
      address,
      city,
      kecamatan,
      businessName,
      province,
      postalCode,
    };
    this.props.appendBusinessOpeningClevertap(clevertapData);
    clevertapKyb.clevertapTracker('KYB KTP Information Start', clevertapData);
  }

  componentWillUnmount() {
    $('#kybInfo').remove();
    $('#upload-photo').remove();
  }

  goBack = () => {
    const { editMode } = this.props.data.kybForm;
    if (editMode) {
      this.props.dispatch(goToStep(5));
    } else {
      this.props.dispatch(goToStep(2));
    }
  };

  handleUpload = e => {
    const file = e.target.files[0];
    const fileSizeAllowed = Math.pow(10, 7); // 10 MB
    if (file && file.size < fileSizeAllowed) {
      const reader = new FileReader();
      reader.onload = e => {
        this.setState(
          {
            url: reader.result,
            file,
          },
          () => {
            e.target.value = null;
            $('#upload-photo').modal({
              backdrop: 'static',
              keyboard: false,
              show: true,
            });
          }
        );
      };
      reader.readAsDataURL(file);
    } else if (file && file.size > fileSizeAllowed) {
      this.props.dispatch(msgError('Maximum file is 10 MB'));
      e.target.value = null;
    }
  };

  uploadFile = () => {
    const { business } = this.props.data.moka.user;
    const businessId = business.id;
    const data = {
      file: this.state.file,
      id: businessId,
    };
    this.props.dispatch(uploadFile(data));
  };

  selectImage = () => {
    this.uploadFile();
  };

  render() {
    const { handleSubmit, valid, data } = this.props;
    const { idCard, editMode } = data.kybForm;
    const { business_entity_type: businessEntityType } = data.kybForm.kybData;
    const { url } = this.state;
    return (
      <div>
        <form onSubmit={handleSubmit}>
          <div className="col-md-8 col-md-offset-2">
            <h2>
              {businessEntityType === 'corporate'
                ? `${editMode ? 'Edit' : 'Add'} director’s ID Card (KTP)`
                : `${editMode ? 'Edit' : 'Add'} your ID`}
            </h2>
            <div className={`${styles['business-form']}`}>
              <div className="form-group">
                <div className={`${styles['image-upload']}`}>
                  <label
                    htmlFor="file-input"
                    data-toggle="modal"
                    data-target={idCard !== null ? '#upload-photo' : ''}
                    data-backdrop="static"
                    data-keyboard="false"
                  >
                    <img
                      src={
                        idCard !== null
                          ? idCard
                          : 'https://s3-ap-southeast-1.amazonaws.com/image.mokapos.com/growth/backoffice/kyb/upload-icon.png'
                      }
                    />
                  </label>
                  <div>
                    {!idCard && (
                      <input
                        type="file"
                        id="file-input"
                        name="file"
                        onChange={this.handleUpload}
                        accept="image/*"
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="form-group">
                <label>Name on ID Card (KTP)</label>
                <Field
                  component={inputField}
                  name="name"
                  placeholder="Name on ID Card (KTP)"
                  autoCorrect="off"
                  maxLength="30"
                  autoCapitalize="off"
                  spellCheck="false"
                />
              </div>
              <div className="form-group">
                <label>ID Card (KTP) Number</label>
                <Field
                  component={InputNumber}
                  customErrorClassName={styles['input-error']}
                  name="id"
                  placeholder="ID Card (KTP) Number"
                  maxLength="16"
                />
              </div>
            </div>
          </div>
          <a
            href="#"
            className={`${styles.info}`}
            data-toggle="modal"
            data-target="#kybInfo"
          >
            How does this work?
          </a>
          <div className={`col-md-8 col-md-offset-2 ${styles['flex-display']}`}>
            <div className={`col-md-6 col-sm-6 col-xs-6 ${styles['form-btn']}`}>
              <button
                className={`btn btn-block btn-default ${styles['back-btn']}`}
                type="button"
                onClick={this.goBack}
              >
                Back
              </button>
            </div>
            <div className={`col-md-6 col-sm-6 col-xs-6 ${styles['form-btn']}`}>
              <button
                className={`btn btn-primary btn-block`}
                disabled={!(idCard && valid)}
                type="submit"
              >
                {editMode ? 'Save Changes' : 'Next'}
              </button>
            </div>
          </div>
        </form>
        <Modal
          title={
            businessEntityType === 'corporate'
              ? `Adding director's ID Card (KTP)`
              : 'Adding your ID'
          }
        >
          <div className={`${styles['modal-content']}`}>
            {businessEntityType === 'corporate' ? (
              <p>
                When you’re asked for an ID Card (KTP), you need to either take
                a new photo of your KTP/SIM, or upload an existing one from your
                mobile device.
              </p>
            ) : (
              <p>
                When you’re asked for an ID, you need to either take a new photo
                of your KTP/SIM, or upload an existing one from your mobile
                device.
              </p>
            )}
            {businessEntityType === 'corporate' ? (
              <p>
                This ID Card (KTP) needs to belong to the CEO,
                Founder/Cofounder, or the Director of your company. The name and
                ID Card (KTP) number you input here also needs to match that of
                the photo of your ID Card (KTP).
              </p>
            ) : (
              <p>
                This ID needs to be under the same name as the name you used for
                registration. The name and ID number you input here also needs
                to match that of the photo of your ID.
              </p>
            )}
            <p>
              When you upload images of the front of your KTP/SIM, you need to
              make sure your images aren’t blurry. The file size limit for these
              images are 10 MB.
            </p>
          </div>
        </Modal>
        <Modal id="upload-photo" title={`Confirm photo of ID Card (KTP)`}>
          <div className={`${styles['modal-content']}`}>
            <div className={`${styles['uploaded-img']}`}>
              <img src={url !== null ? url : idCard} alt="image" />
            </div>
            <div className={`${styles['upload-modal-btn']}`}>
              {url && (
                <button
                  className={`btn btn-block btn-primary`}
                  type="button"
                  onClick={this.selectImage}
                >
                  Use Photo
                </button>
              )}
              <input
                type="file"
                name="file"
                id="reupload"
                className={`${styles.reupload}`}
                onChange={this.handleUpload}
                accept="image/*"
              />
              <label
                className={`${styles['reupload-label']}`}
                htmlFor="reupload"
              >
                Reupload Photo
              </label>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
};

DocumentUpload = reduxForm({
  form: 'DocumentUpload',
  touchOnBlur: false,
  touchOnChange: true,
  validate,
})(DocumentUpload);

function select(state) {
  return {
    data: state,
  };
}

export default connect(select)(DocumentUpload);
